import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class HttpRequest {
    constructor(private http: HttpClient) { }
    //post
    setElement(data: any) {
        // SCRIVERE DB
        return this.http.post<any>(`${environment.apiUrl}/admin/devices/`, data); // URL BACKEND
    }
    //Get
    getUrl(index: number) { //find all devices
        // OTTENERE QUALCOSA
        return this.http.get<string>(`${environment.apiUrl}/test/data`);
    }
    getUrlFile() { //find all devices
        // OTTENERE QUALCOSA
        return this.http.get<JSON>(`${environment.apiUrl}/test/data`);
    }

    getFile(url: string) {
        return this.http.get<JSON>(url);
    }
}